import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
// import "./vehiclelist.css";
import back from "../../../assets/svg/backarrow.svg";
import search from "../../../assets/svg/search.svg";
import plus from "../../../assets/svg/plus.svg";
import edit from "../../../assets/svg/edit.svg";
import del from "../../../assets/svg/delete.svg";
import close from "../../../assets/svg/close.svg";
import ReactPaginate from "react-paginate";
import df from "../../../assets/svg/df.svg";
import SearchWithAPI from "../../searchbox/searchbox.js";
// import VehicleAdd from "./vehicleadd";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteModal from "../../common/delete-modal.js";
import mawalog from "../../../assets/svg/mawaloglogo.svg";
import { getTransporterListApi } from "../customers/customer-api.js";
import CustomerTabs from "../set-bar.js";
import { getDeptListApi, getEditApi, getFieldListApi, getGateListApi, getListApi, getOptionsListApi, registerSubmitApi, UpdateFieldsApi } from "./registerfield-api.js";

export default function RegisterFieldAdd() {
  //useLocation
  const location = useLocation();
  const { id } = location.state || {};
  const navigate = useNavigate();

  const [visitorOptions, setVisitorOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  //inputs

  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  const [fieldName, setFieldName] = useState([]);

  const [fieldOptions, setFieldOptions] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    fields: "",
  });

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };
  const [options, setOptions] = useState([]);
  const getOptionData = async (tab) => {
    try {
      const response = await getListApi(tab);
      if (response.data.success === true) {
        const transformed = response.data.fields.map((field) => ({
          field_name: field.field_name || field, // adapt to API shape
          enabled: field.enabled ?? false,
          mandatory: field.mandatory ?? false,
        }));

        setFieldName(transformed);
      }
    } catch (err) {
      console.error("Error fetching fields:", err);
    }
  };

  //Gate
  const [gate, setGate] = useState([]);
  const fetchGate = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getGateListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleGateChange = (selectedOptions) => {
    setGate(selectedOptions);
  };

  //Department
  const [department, setDepartment] = useState([]);
  const fetchDepartment = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching department options with term:", inputValue);
      const response = await getDeptListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleDepartmentChange = (selectedOptions) => {
    setDepartment(selectedOptions);
  };

  const handleToggle = (selectedOption) => {
    const updated = fieldName.map((opt) => (opt.field_name === selectedOption.field_name ? { ...opt, enabled: !opt.enabled, mandatory: false } : opt));
    setFieldName(updated);
  };

  const handleMandToggle = (selectedOption) => {
    const updated = fieldName.map((opt) => (opt.field_name === selectedOption.field_name ? { ...opt, mandatory: !opt.mandatory } : opt));
    setFieldName(updated);
  };

  const submitform = async (value) => {
    const payload = {
      code: code,
      name: name,
      docks: gate?.filter((item) => item.value !== "").map((item) => item.value),
      departments: department?.filter((item) => item.value !== "").map((item) => item.value),
      fields: fieldName,
    };
    let response;
    if (id != null) {
      response = await UpdateFieldsApi(payload, id);
      navigate("/registerfields");
    } else {
      response = await registerSubmitApi(payload);
    }
    console.log(response, "response");
    console.log("response.status", response.status);

    if (response.success === true) {
      setSnackbarMessage(response.message);
      setSnackbarStatus(response.status);
      handleSnackbarShow();
      navigate("/registerfields");

      setValidations({
        code: "",
        name: "",
        fields: "",
      });
    }

    if (response.success === false) {
      const validationErrors = response.error || {};
      const validationTemp = {
        code: validationErrors.code || "",
        name: validationErrors.name || "",
        fields: validationErrors.fields || "",
      };
      setValidations(validationTemp);
      console.log("validations", validations);
    }
  };

  useEffect(() => {
    if (id != null) {
      getFieldsDetails();
    } else {
      getOptionData();
    }
  }, []);

  const getFieldsDetails = async () => {
    try {
      const response = await getEditApi(id);
      console.log(response);
      if (response.status === true || response.config != null) {
        const config = response.config; // Get the first call

        setCode(config.code);
        setName(config.name);
        setGate(config.gates);
        setDepartment(config.departments);
        // Fetch full field list first
        const masterFieldRes = await getFieldListApi();
        const masterFields = masterFieldRes.data.fields.map((item) => ({
          field_name: item,
          enabled: false,
          mandatory: false,
        }));

        // Now merge config.fields with master list
        const fieldStatesFromConfig = config.fields;
        const updatedFieldList = masterFields.map((field) => {
          const match = fieldStatesFromConfig.find((f) => f.field_name === field.field_name);
          return {
            ...field,
            enabled: match ? match.enabled : false,
            mandatory: match ? match.mandatory : false,
          };
        });

        setFieldName(updatedFieldList);
      }
    } catch (err) {
      console.error("Error fetching call details:", err);
    }
  };

  const getListData = async () => {
    try {
      const response = await getFieldListApi();
      if (response.data.success === true) {
        const formattedFields = response.data.fields.map((item) => ({
          field_name: item,
          enabled: false,
          mandatory: false,
        }));
        setFieldName(formattedFields);
      }
    } catch (err) {
      console.error("Error fetching field list:", err);
    }
  };

  useEffect(() => {
    if (id == null) {
      getListData();
    }
  }, []);

  return (
    <div className="customer-container mb-2">
      {/* {isOpenDelete && (<DeleteModal deleteUrl={`transporter/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />)} */}

      <div className="customer-header">
        <div
          className="customer-back-button"
          onClick={() => {
            navigate(-1);
          }}>
          <img src={back} alt="Back" className="customer-backicon" />
        </div>
        <h1>Admin Setup</h1>
      </div>
      <div className="customer-card">
        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "20px", backgroundColor: "#FFFFFF" }}>
          <div style={{ marginBottom: "40px" }}>
            <Row className="align-items-center" style={{ marginBottom: "32px" }}>
              <Col xs={12} md={6}>
                <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Create new template</div>
              </Col>
              <Col xs={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap" }}>
                  <button style={{ borderRadius: "10px", height: "44px", border: "1px solid #e5e5e5", padding: "10px 32px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "14px", color: "#172b4d", cursor: "pointer" }} onClick={() => navigate("/registerfields")}>
                    Cancel
                  </button>
                  <button onClick={() => submitform()} className="head_btn" style={{height:'44px', cursor:'pointer',borderRadius: "10px"}}>
                    Save
                  </button>
                </div>
              </Col>
            </Row>

            <Row className="align-items-center" style={{ width: "100%" }}>
              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                    Code <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input type="text" placeholder="Enter code" value={code} onChange={(e) => setCode(e.target.value)} style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#172b4d", width: "100%" }} />
                    <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.code}</span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                    Template Name <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter code" style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#172b4d", width: "100%" }} />
                    <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.name}</span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>Dock</div>
                  <div>
                    <AsyncSelect isMulti cacheOptions value={gate} loadOptions={fetchGate} onChange={handleGateChange} defaultOptions placeholder="Search dock..." styles={multiselectCustomStyles} isClearable={false} />
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>Department</div>
                  <div>
                    <AsyncSelect isMulti cacheOptions value={department} loadOptions={fetchDepartment} onChange={handleDepartmentChange} defaultOptions placeholder="Search department..." styles={multiselectCustomStyles} isClearable={false} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", padding: "16" }}>
            <div style={{ borderRadius: "16px", padding: "20px 16px 16px 16px", backgroundColor: "#F8F8F8", display: "flex", flexDirection: "column", gap: "12px", width: "100%" }}>
              <div>
                <div style={{ marginBottom: "12px", fontWeight: "600", fontSize: "13px", color: "#8790A1" }}>Configurations</div>

                <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.vehicle_fields}</span>

                <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.visitor_fields}</span>

                <Row style={{ rowGap: "0px" }}>
                  {fieldName.map((option) => (
                    <Col md={6} key={option.field_name} style={{marginBottom:'15px'}}>
                    <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "70px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ fontWeight: "600", fontSize: "14px", color: "#174b4d" }}>{option.field_name}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          {option.enabled && (
                            <>
                              <div style={{ paddingLeft: "12px", paddingRight: "12px", borderRadius: "10px", backgroundColor: "#F8F8F8", display: "flex", alignItems: "center" }}>
                                <div style={{ padding: "4px", marginRight: "8px" }}>
                                  <input type="checkbox" checked={option.mandatory} onChange={() => handleMandToggle(option)} style={{ width: "20px", height: "20px", accentColor: "#2C8C53", cursor: "pointer", marginTop: "3px", borderRadius: "6px", transform: "scale(0.8)", outline: "1px solid #ccc" }} />
                                </div>
                                <div onClick={() => handleMandToggle(option)} style={{ fontWeight: "500", fontSize: "13.5px", cursor: "pointer", color: "#172b4d" }}>
                                  Mandatory
                                </div>
                              </div>
                              <div style={{ width: "1px", height: "28px", backgroundColor: "#E5E5E5" }}></div>
                            </>
                          )}
                          <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                            <input type="checkbox" checked={option.enabled} onChange={() => handleToggle(option)} style={{ opacity: 0, width: 0, height: 0 }} />
                            <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: option.enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                            <span style={{ position: "absolute", height: "18px", width: "18px", left: option.enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    </Col>
                  ))}
                </Row>

                <div style={{ marginTop: "20px" }}>
                  {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button onClick={() => submitform()} style={{ borderRadius: "100px", border: "1px solid #E5E5E5", padding: "10px 28px", backgroundColor: "#2C8C53", fontWeight: "700", fontSize: "14px", width: "160px", color: "#FFFFFF", cursor: "pointer" }}>
                      Update
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "30px", fontWeight: "400", fontSize: "12px", color: "#172B4D" }}>
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>

      {/* Modal for VehicleAdd */}
      {/* {isModalVisible && <VehicleAdd typeId={typeId} onSuccess={onSuccessVehicleType} onClose={closeModal} />} */}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
